const {LINK_ADMIN_ROOT, LINK_ADMIN_DASHBOARD, LINK_ADMIN_TRX, LINK_ADMIN_CUSTOMERS, LINK_ADMIN_RETAILERS,
  LINK_ADMIN_RULES, LINK_ADMIN_PARTNERS, LINK_ADMIN_ANALYTICS, LINK_ADMIN_SETTINGS, LINK_ADMIN_WITHDRAWS,
  LINK_ADMIN_SETTLEMENTS, LINK_ADMIN_STATEMENTS
} = require('../../../../../../constants/links');

const {
  NavIconDashboard,
  NavIconTrx,
  NavIconCustomers,
  NavIconRetailers,
  NavIconGlobals,
  NavIconStatements,
  NavIconPartners,
  NavIconAnalytics,
  NavIconWithdraws,
  NavIconSettings
} = require('./icons');

const formLink = (...rest) => [LINK_ADMIN_ROOT, ...rest].join('');

module.exports = [{
  id: 'dashboard',
  title: 'Dashboard',
  link: formLink(LINK_ADMIN_DASHBOARD),
  icon: NavIconDashboard,
  isStrict: true
}, {
  id: 'trx',
  title: 'Transactions',
  link: formLink(LINK_ADMIN_TRX),
  icon: NavIconTrx
}, {
//   id: 'customers',
//   title: 'Customer management',
//   link: formLink(LINK_ADMIN_CUSTOMERS),
//   icon: NavIconCustomers
// }, {
  id: 'retailers',
  title: 'Retailer management',
  link: formLink(LINK_ADMIN_RETAILERS),
  icon: NavIconRetailers
}, {
  id: 'settlements',
  title: 'Statements Statistic',
  link: formLink(LINK_ADMIN_STATEMENTS),
  icon: NavIconStatements
}, {
  id: 'globals',
  title: 'Global Rules',
  link: formLink(LINK_ADMIN_RULES),
  icon: NavIconGlobals
// }, {
//   id: 'partners',
//   title: 'Partner management',
//   link: formLink(LINK_ADMIN_PARTNERS),
//   icon: NavIconPartners
// }, {
//   id: 'analytics',
//   title: 'Product Analytics',
//   link: formLink(LINK_ADMIN_ANALYTICS),
//   icon: NavIconAnalytics
// }, {
//   id: 'settings',
//   title: 'Settings',
//   link: formLink(LINK_ADMIN_SETTINGS),
//   icon: NavIconSettings
}];
